export default "__VITE_ASSET__ycEJ9fvb__"